import { useHookstate } from "@hookstate/core";
import { Release } from "../../../../types";
import { readerDataStore } from "../../../../hookstate/readerDataStore";

export function useReleaseData() {
  const releaseData = useHookstate(readerDataStore.releaseData).get({
    noproxy: true,
  });

  const setReleaseData = (data: Release) => {
    readerDataStore.releaseData.set(data);
  };

  return { releaseData, setReleaseData };
}
